// TODO 工具类
import {
  apiAreaPage,
  apiGetCarLineDispatchSystemList,
  apiGetCarLineList,
  apiOptionForSelect,
  apiProviderChannel,
  apiProviderPage,
  apiSiteQuery, queryCarNumber, queryDriver, queryInsuranceType
} from '@/api/finance/basicData';
import { apiPartitionPage, feePage } from '@/api/finance/partition';
import { apiGetCustomerPage } from '@/api/finance/contasDeClientes';
import { searchSiteIdList } from '@/api/lanshou';

export default {
  data() {
    return {
      providerList: [], // 主体选项ALL
      providerData: [], // 分页主体下拉数据
      transportationProviderList: [], // 运输主体
      outletsList: [], // 网点列表
      outletsAllList: [], // 所有网点
      ProviderChannelList: [], // 服务商渠道
      expenseTypeList: [], // 普通费用类型
      specialFeeList: [], // 特殊费用类型
      feeList: [], // 所有费用类型
      partitionList: [], // 分区方案下拉数据
      allState: [], // 所有州
      allCity: [], // 所有城市
      modelList: [], // 车型
      stitchingLine: [], // 车线
      customerOption: [], // 客户下拉
      vehicleList: [], // 车牌号
      driverList: [], // 司机
      insuranceTypeList: [], // 保险类型
      paymentMethod: [], // 付款方式
      locationType: [], // 装卸类型
      exportKey: new Date().getTime() // key用于更新组件
    };
  },
  methods: {
    /**
     * 请求主体ALL
     */
    getProviderPage() {
      const param = {
        pageSize: 9999999,
        pageNumber: 1,
        params: {
          state: 1
        }
      };
      apiProviderPage(param, false).then(res => {
        if (res.code === 200) {
          // const dataList = res.data.records;
          // // 1.判断是否是新增的主体
          // if (this.operationType && this.operationType !== 1) {
          //   // 判断主体是否存在，避免出现错误主体
          //   const list = dataList.filter(item => item.id === this.editData.payableEntityId);
          //   if (list.length === 0) {
          //     const obj = {
          //       providerName: this.editData.payableEntityName,
          //       id: this.editData.payableEntityId
          //     };
          //     dataList.push(obj);
          //   }
          // }
          this.providerList = res.data.records;
        }
      }).catch(err => {
        console.log(err);
      });
    },
    /**
     * 获取分页主体下拉数据
     */
    getProviderList(name = '') {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          providerBody: name,
          state: 1
        }
      };
      apiProviderPage(param, false).then(res => {
        if (res.code === 200) {
          this.providerData = res.data.records || [];
        }
      });
    },
    /**
     * 获取运输应付主体下拉数据
     */
    getTransportationProviderPage() {
      apiOptionForSelect({ providerName: '', status: 2 }, false).then(res => {
        if (res.code === 200) {
          this.transportationProviderList = (res.data || []).map(item => {
            return {
              providerName: item.name,
              code: item.code,
              id: item.providerId
            };
          });
        }
      }).catch(err => {
        console.log(err);
      });
    },
    /**
     * 主体id获取网点下拉数据
     * @params id 主体id
     */
    getSiteQuery(id) {
      apiSiteQuery(id, false).then(res => {
        if (res.code === 200) {
          this.outletsList = res.data;
        }
      });
    },
    /**
     * 查询ALL可用网点
     */
    getAllSiteQuery() {
      searchSiteIdList().then(res => {
        if (res.code === 200) {
          this.outletsAllList = res.data;
        }
      });
    },
    /**
     * 获取服务商下拉数据
     * @params id 主体id
     */
    getProviderChannel() {
      const query = {
        pageNumber: 1,
        pageSize: 9999999,
        params: {
          providerChannelCode: '',
          providerChannelName: ''
        }
      };
      apiProviderChannel(query).then(res => {
        if (res.code === 200) {
          this.ProviderChannelList = res.data.records || [];
        }
      });
    },
    /**
     * 获取费用类型
     * @params params 查询参数
     */
    getExpenseTypeList(params) {
      const param = {
        orderDirection: 'ASC',
        pageNumber: 1,
        pageSize: 9999999,
        params: {
          ...params
        }
      };
      feePage(param, false).then(res => {
        const { code, data } = res;
        if (code === 200) {
          this.expenseTypeList = (data.records || []).filter(item => item.specialRules === null) || []; // 筛选非特殊费用
          this.specialFeeList = (data.records || []).filter(item => item.specialRules !== null) || []; // 筛选特殊费用
          this.feeList = data.records;
          this.exportKey = new Date().getTime();
        }
      }).catch(() => {
        this.expenseTypeList = []; // 筛选非特殊费用
        this.specialFeeList = []; // 筛选特殊费用
        this.feeList = [];
      });
    },
    /**
     * 分区方案下拉数据
     * @params attribute 1 应收 2 应付
     */
    getSubregionData(attribute) {
      const param = {
        pageNumber: 1,
        pageSize: 9999999,
        params: {
          attribute,
          state: 1
        }
      };
      apiPartitionPage(param).then(res => {
        const { code, data } = res;
        if (code !== 200) {
          return;
        }
        this.partitionList = data.records;
      });
    },
    // 获取所有的州
    getAllState(row) {
      const param = {
        pageNumber: 1,
        pageSize: 99999,
        params: {
          level: row.level,
          parentId: row.parentId
        }
      };
      apiAreaPage(param).then(res => {
        if (res.code === 200) {
          const func = function(data) {
            return data.map(item => ({
              label: item.twoCode,
              value: item.id,
              name: item.name
            }));
          };
          if (row.level === 1) {
            this.allState = func(res.data.records);
          } else {
            this.allCity = func(res.data.records);
          }
        }
      });
    },
    /**
     * 获取车线下拉数据
     */
    getApiCarLineDispatchSystemList() {
      apiGetCarLineDispatchSystemList({
        lineName: '',
        status: 2
      }).then(res => {
        if (res.code === 200) {
          this.stitchingLine = res.data || [];
        }
      });
    },
    /**
     * 获取车型下拉数据
     */
    getApiOptionForSelect() {
      apiGetCarLineList().then(res => {
        if (res.code === 200) {
          this.modelList = res.data || [];
        }
        console.log('获取车型下拉数据', this.modelList);
      });
    },
    // 获取客户选项
    getCustomerOption(name) {
      const param = {
        pageSize: 99999999,
        pageNumber: 1,
        params: {
          quickSearch: name
        }
      };
      apiGetCustomerPage(param).then(res => {
        if (res.code === 200) {
          this.customerOption = res.data.records;
        }
      });
    },

    // 获取车牌号（调度系统）
    getCarNumber() {
      queryCarNumber().then(res => {
        if (res.code === 200) {
          this.vehicleList = res.data;
        }
      });
    },

    // 获取司机信息（调度系统）
    getDriverInfo() {
      queryDriver().then(res => {
        if (res.code === 200) {
          this.driverList = res.data;
        }
      });
    },

    // 获取调度字典
    getInsuranceType(type) {
      queryInsuranceType(type).then(res => {
        const { code, data } = res;
        if (code === 200) {
          if (type === 'insurance_type') {
            this.insuranceTypeList = data;
          }
          if (type === 'load_unload_type') {
            this.locationType = data;
          }
          if (type === 'payment_method') {
            this.paymentMethod = data;
          }
        }
      });
    }
  }
};

